import { Injectable } from '@angular/core';
import {Socket} from "socket.io-client";
import {DefaultEventsMap} from "@socket.io/component-emitter";
import {FileUploadStatus} from "../../state/interface/dtos/file-upload-status.dto";
import ServerFile from "./dtos/server-file.dto";
import {Store} from "@ngrx/store";
import {settings} from "../../settings/settings";

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  fileDownloadsById: {[fileId: string]: {
      file: ServerFile,
      downloadCompleted: boolean,
    }} = {}

  constructor(
      private store: Store,
  ) { }

  async setupFileReciever(fileSocket: Socket) {

  }

  async getFile(fileId: string, fileSocket: Socket): Promise<ServerFile> {
    if (settings.onlyUseFirstDownloadedImage) {
      if (Object.keys(this.fileDownloadsById).length > 0) {
        const key = Object.keys(this.fileDownloadsById)[0]
        const fileDownload = this.fileDownloadsById[key];
        while (!fileDownload?.downloadCompleted) {
          // console.log(`[File downloader] Waiting for file (${fileId}) download to complete`)
          await this.sleep(1)
        }
        // console.log(`[File downloader] File (${fileId}) already downloaded, returning cached value`);
        return fileDownload.file;
      }
    }
    if (Object.keys(this.fileDownloadsById).includes(fileId)) {
      const fileDownload = this.fileDownloadsById[fileId];
      while (!fileDownload?.downloadCompleted) {
        // console.log(`[File downloader] Waiting for file (${fileId}) download to complete`)
        await this.sleep(1)
      }
      // console.log(`[File downloader] File (${fileId}) already downloaded, returning cached value`);
      return fileDownload.file;
    }
    // console.log(`[File downloader] Downloading file (${fileId})`);
    this.fileDownloadsById[fileId] = {
      file: null,
      downloadCompleted: false,
    };
    try {
      console.log('socket connected?', fileSocket.connected)
      console.log('socket id?', fileSocket.id)

      fileSocket.onAny((event, ...args) => console.log('incoming:', event, args))

      const response: ServerFile = await fileSocket.emitWithAck("get_file", {
        id: fileId,
      });
      this.fileDownloadsById[fileId].file = response
      this.fileDownloadsById[fileId].downloadCompleted = true
      // console.log(`[File downloader] (${fileId}): ${response ? "success" : "failed"}`);
      return response;
    } catch (e) {
      console.log(`[File downloader] (${fileId}): ${e}`);
      return null;
    }
  }

  async downloadFile(doc, data: any, fileName: any) {
    const src = data;
    const link = doc.createElement("a");
    link.href = src;
    link.download = fileName;
    await link.click();
    link.remove();
  }

  sleep(seconds: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
  }
}
